import React from "react";
import { useGlobalData } from "../context/GlobalDataContext";
import { Link } from "react-router-dom";
import "./HeadTable.css";


function HeadTable() {
  const { headTable, loading } = useGlobalData();
  const links = headTable;
  if (loading) {
    return (
      <div className="headtable">
        <table className="latest-table">
          <tbody>
            <tr>
              <td className="latest-table-label" style={{animation: 'shimmer 3s infinite', backgroundColor: '#e5e7eb', borderRadius: '4px', minHeight: '24px', width: '120px'}}></td>
              <td className="latest-table-marquee-cell">
                <div style={{backgroundColor: '#f3f4f6', borderRadius: '4px', height: '28px', animation: 'shimmer 3s infinite'}}></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
  if (!links || links.length === 0) {
    return <div className="headtable"><p className="headtable-status headtable-status-empty">No items in HeadTable yet</p></div>;
  }

  return (
    <div className="headtable">
      <table className="latest-table">
        <tbody>
          <tr>
            <td className="latest-table-label">{links[0]?.label || "Latest Updates"}</td>
            <td className="latest-table-marquee-cell">
              <div className="latest-table-marquee" aria-label="Latest updates">
                <div className="latest-table-track">
                  {/* Start sign */}
                  <span className="latest-table-start-sign" title="Data starts here">▶</span>
                  {links.map((link, i) => (
                    <React.Fragment key={link._id ? `${link._id}-marquee-start-${i}` : `${link.slug}-marquee-start-${i}`}>
                      <Link to={`/mform/${link.jobSlug}`} className="headtable-link">
                        {link.title}
                      </Link>
                      <span className="latest-table-separator">|</span>
                    </React.Fragment>
                  ))}
                  {/* Repeat sign at the loop point */}
                  <span className="latest-table-repeat-sign" title="Data repeats from here">🔁</span>
                  {links.map((link, i) => (
                    <React.Fragment key={link._id ? `${link._id}-marquee-repeat-${i}` : `${link.slug}-marquee-repeat-${i}`}>
                      <Link to={`/mform/${link.jobSlug}`} className="headtable-link">
                        {link.title}
                      </Link>
                      <span className="latest-table-separator">|</span>
                    </React.Fragment>
                  ))}
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default HeadTable;
